import { Paper, Text, Table, Badge } from "@mantine/core";

/**
 * Tabla comparativa de vendedores con:
 * - Nombre, leads asignados, convertidos, perdidos, en progreso
 * - Tasa de conversión, promedio de intentos
 * - Ranking natural por conversiones
 */
export default function SellerPerformanceTable({ sellers }) {
    if (!sellers || sellers.length === 0) {
        return (
            <Paper shadow="sm" radius="md" p="lg">
                <Text fw={600} size="lg" mb="sm">
                    Performance por vendedor
                </Text>
                <Text size="sm" c="dimmed">
                    No hay datos de vendedores para el período seleccionado.
                </Text>
            </Paper>
        );
    }

    return (
        <Paper shadow="sm" radius="md" p="lg" style={{ overflowX: "auto" }}>
            <Text fw={600} size="lg" mb="md">
                Performance por vendedor
            </Text>

            <Table striped highlightOnHover withTableBorder>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th>#</Table.Th>
                        <Table.Th>Vendedor</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Leads</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>En progreso</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Convertidos</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Perdidos</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Conversión</Table.Th>
                        <Table.Th style={{ textAlign: "center" }}>Prom. intentos</Table.Th>
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {sellers.map((seller, idx) => (
                        <Table.Tr key={seller._id || idx}>
                            <Table.Td>
                                <Text fw={600} size="sm">
                                    {idx + 1}
                                </Text>
                            </Table.Td>
                            <Table.Td>
                                <Text size="sm" fw={500}>
                                    {seller.sellerName}
                                </Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "center" }}>
                                <Text size="sm">{seller.totalLeads}</Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "center" }}>
                                <Text size="sm" c="blue">
                                    {seller.inProgress}
                                </Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "center" }}>
                                <Text size="sm" c="green" fw={600}>
                                    {seller.converted}
                                </Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "center" }}>
                                <Text size="sm" c="red">
                                    {seller.lost}
                                </Text>
                            </Table.Td>
                            <Table.Td style={{ textAlign: "center" }}>
                                <ConversionBadge rate={seller.conversionRate} />
                            </Table.Td>
                            <Table.Td style={{ textAlign: "center" }}>
                                <Text size="sm">{seller.avgAttempts}</Text>
                            </Table.Td>
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
        </Paper>
    );
}

function ConversionBadge({ rate }) {
    let color = "red";
    if (rate >= 30) color = "green";
    else if (rate >= 15) color = "yellow";

    return (
        <Badge variant="light" color={color} size="md">
            {rate}%
        </Badge>
    );
}
